import React, { useState } from 'react';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
import { Mail, Phone, Linkedin, Send } from 'lucide-react';
export function ContactSection() {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
      setFormState({
        name: '',
        email: '',
        company: '',
        message: ''
      });
    }, 1500);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value
    });
  };
  return <section id="contact" className="py-24 bg-navy-900" data-id="element-81">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-82">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-83">
          <div data-id="element-84">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-85">
              Let's <span className="text-gradient" data-id="element-86">Connect</span>
            </h2>
            <p className="text-lg text-white/50 mb-10 max-w-md" data-id="element-87">
              Available for executive roles, board positions, and strategic
              advisory engagements. Reach out to discuss how we can drive
              revenue growth together.
            </p>

            <div className="space-y-6" data-id="element-88">
              <a href="mailto:tom@hyroadconsulting.com" className="flex items-center gap-4 p-4 rounded-xl bg-navy-800 border border-navy-700 hover:border-gold/40 transition-colors group" data-id="element-89">
                <div className="w-12 h-12 rounded-full bg-gold/10 flex items-center justify-center text-gold group-hover:bg-gold group-hover:text-navy-900 transition-colors" data-id="element-90">
                  <Mail className="w-5 h-5" data-id="element-91" />
                </div>
                <div data-id="element-92">
                  <p className="text-sm text-white/40 mb-1" data-id="element-93">Email</p>
                  <p className="font-medium text-white" data-id="element-94">
                    tom@hyroadconsulting.com
                  </p>
                </div>
              </a>

              <div className="flex items-center gap-4 p-4 rounded-xl bg-navy-800 border border-navy-700" data-id="element-95">
                <div className="w-12 h-12 rounded-full bg-navy-700 flex items-center justify-center text-white/40" data-id="element-96">
                  <Phone className="w-5 h-5" data-id="element-97" />
                </div>
                <div data-id="element-98">
                  <p className="text-sm text-white/40 mb-1" data-id="element-99">Phone</p>
                  <p className="font-medium text-white" data-id="element-100">
                    Available upon request
                  </p>
                </div>
              </div>

              <a href="#" className="flex items-center gap-4 p-4 rounded-xl bg-navy-800 border border-navy-700 hover:border-gold/40 transition-colors group" data-id="element-101">
                <div className="w-12 h-12 rounded-full bg-gold/10 flex items-center justify-center text-gold group-hover:bg-gold group-hover:text-navy-900 transition-colors" data-id="element-102">
                  <Linkedin className="w-5 h-5" data-id="element-103" />
                </div>
                <div data-id="element-104">
                  <p className="text-sm text-white/40 mb-1" data-id="element-105">LinkedIn</p>
                  <p className="font-medium text-white" data-id="element-106">
                    Connect professionally
                  </p>
                </div>
              </a>
            </div>
          </div>

          <div data-id="element-107">
            <Card className="p-8" data-id="element-108">
              <h3 className="text-2xl font-bold text-white mb-6" data-id="element-109">
                Send a Message
              </h3>

              {isSubmitted ? <div className="bg-emerald-900/20 border border-emerald-800 text-emerald-400 p-6 rounded-lg text-center" data-id="element-110">
                  <div className="w-12 h-12 rounded-full bg-emerald-900/50 flex items-center justify-center mx-auto mb-4" data-id="element-111">
                    <Send className="w-6 h-6" data-id="element-112" />
                  </div>
                  <h4 className="text-lg font-semibold mb-2" data-id="element-113">Message Sent</h4>
                  <p className="text-sm" data-id="element-114">
                    Thank you for reaching out. I'll get back to you shortly.
                  </p>
                  <Button variant="outline" className="mt-6" onClick={() => setIsSubmitted(false)} data-id="element-115">
                    Send Another Message
                  </Button>
                </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-116">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-117">
                    <div className="space-y-2" data-id="element-118">
                      <label htmlFor="name" className="text-sm font-medium text-white/60" data-id="element-119">
                        Name
                      </label>
                      <input type="text" id="name" name="name" required value={formState.name} onChange={handleChange} className="w-full bg-navy-800 border border-navy-600 rounded-md px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-gold focus:border-transparent transition-all placeholder:text-white/20" placeholder="John Doe" data-id="element-120" />
                    </div>
                    <div className="space-y-2" data-id="element-121">
                      <label htmlFor="email" className="text-sm font-medium text-white/60" data-id="element-122">
                        Email
                      </label>
                      <input type="email" id="email" name="email" required value={formState.email} onChange={handleChange} className="w-full bg-navy-800 border border-navy-600 rounded-md px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-gold focus:border-transparent transition-all placeholder:text-white/20" placeholder="john@company.com" data-id="element-123" />
                    </div>
                  </div>

                  <div className="space-y-2" data-id="element-124">
                    <label htmlFor="company" className="text-sm font-medium text-white/60" data-id="element-125">
                      Company
                    </label>
                    <input type="text" id="company" name="company" value={formState.company} onChange={handleChange} className="w-full bg-navy-800 border border-navy-600 rounded-md px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-gold focus:border-transparent transition-all placeholder:text-white/20" placeholder="Company Name" data-id="element-126" />
                  </div>

                  <div className="space-y-2" data-id="element-127">
                    <label htmlFor="message" className="text-sm font-medium text-white/60" data-id="element-128">
                      Message
                    </label>
                    <textarea id="message" name="message" required rows={4} value={formState.message} onChange={handleChange} className="w-full bg-navy-800 border border-navy-600 rounded-md px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-gold focus:border-transparent transition-all resize-none placeholder:text-white/20" placeholder="How can we work together?" data-id="element-129"></textarea>
                  </div>

                  <Button type="submit" className="w-full" disabled={isSubmitting} data-id="element-130">
                    {isSubmitting ? 'Sending...' : 'Send Message'}
                  </Button>
                </form>}
            </Card>
          </div>
        </div>
      </div>
    </section>;
}